// Where each kind of account lands after signing in.
export const dashboardPath = (role) => ({
  admin: '/dashboard/admin',
  tutor: '/dashboard/tutor',
  student: '/dashboard/student',
  applicant: '/apply',
}[role] || '/');
